import React from 'react';

const SvgMt = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MT_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MT_svg__b" fill="#fff">
        <use xlinkHref="#MT_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#DE233C" mask="url(#MT_svg__b)" d="M14.667 0H28v20H14.667z" />
      <path
        d="M5.667 3.667H7v2H5.667V7h-2V5.667H2.333v-2h1.334V2.333h2v1.334z"
        strokeOpacity={0.66}
        stroke="#7B716A"
        strokeWidth={0.667}
        fill="#CCCCCD"
        mask="url(#MT_svg__b)"
      />
      <circle
        fill="#7B716A"
        mask="url(#MT_svg__b)"
        cx={4.667}
        cy={4.667}
        r={1}
      />
    </g>
  </svg>
);

export default SvgMt;
